import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@AppCore/constants/validator';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  constructor(
    private _sharedService: SharedService,
    private _globalutilityService: GlobalUtilityService
  ) {}

  showSuccessBox: boolean = false;

  contactUsForm: FormGroup = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      CustomValidators.emailOrPhoneValidator(),
    ]),
    full_name: new FormControl('', Validators.required),
    phone: new FormControl('', [
      Validators.required,
      CustomValidators.emailOrPhoneValidator(),
    ]),
    message: new FormControl('', Validators.required),
  });

  submitContactUs() {
    if (this.contactUsForm.valid && this.contactUsForm.dirty) {
      this._sharedService.contactUs(this.contactUsForm.value).subscribe({
        next: (res) => {
          this._globalutilityService.showToast(
            'success',
            'We noted your message. We will get back to you soon.'
          );
          this.showSuccessBox = true;
        },
        error: (err) => {
          this._globalutilityService.showToast('error', err.error.message);
        },
      });
    } else {
      this._globalutilityService.showToast('error', 'Please fill all the fields correctly');
    }
  }
}
